import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import {
  BatchScheduleEventsRes,
  StudentAccess,
  childInfo,
  dueItem,
  nextClass,
  practiceStat,
  classCardColors,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { PracticeTestService } from '../practice-test/practice-test.service';
import { categories } from 'src/app/constants/categories';
import * as moment from 'moment-timezone';
import { CommonService } from 'src/app/services/common.service';
import { ParentChildrenService } from 'src/app/services/parent-children.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { WorkshopService } from 'src/app/modules/workshop/workshop.service';
import { WorkshopStudentModel } from 'src/app/modules/workshop/workshop.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-new-dashboard',
  templateUrl: './new-dashboard.component.html',
  styleUrls: ['./new-dashboard.component.scss'],
})
export class NewDashboardComponent implements OnInit, OnDestroy {
  timezones = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'Asia/Calcutta',
  ];
  assignments: any[] = [];
  events: any[] = [];
  timezone: string = '';
  time: string = '';
  date: string = '';
  interval: any;
  name = '';
  assignmentsLoading: boolean = false;
  eventsLoading: boolean = false;
  // Set when there are no classes this week and the list shows a later week
  eventsFromNote = '';
  private parentChildrenArraySubscription: Subscription | undefined;
  private parentChildrenIndexSubscription: Subscription | undefined;
  selectedChild = 0;
  childrenLoading = true;
  children = <any>[];
  role: string;
  studentAccessSubscription: Subscription;
  studentAccess: StudentAccess | undefined;
  studentId: number | null = null;
  hasChartAccess: boolean = false;
  havePackage: boolean = false;

  roleId: string | null = localStorage.getItem('roleId');

  constructor(
    private globalApiService: GlobalApiService,
    private practiceTestService: PracticeTestService,
    private commonService: CommonService,
    private parentChildrenServcie: ParentChildrenService,
    private httpClient: HttpClient,
    private router: Router,
    private workshopService: WorkshopService
  ) {
    this.role = localStorage.getItem('roleId') || '';
    this.studentAccessSubscription = this.commonService
      .getStudentAccess()
      .subscribe({
        next: (studentAccess: StudentAccess) => {
          this.studentAccess = studentAccess;
        },
      });
  }

  ngOnInit(): void {
    var sone = moment.tz.guess();
    var timezone = moment.tz(sone).zoneAbbr();
    this.timezone = timezone;
    this.interval = setInterval(() => {
      const date = new Date();
      this.time = moment(date).format('hh:mm A');
      this.date = moment(date).format('MMMM DD, YYYY');
    }, 1000);
    this.globalApiService.getUser().subscribe(
      (response: any) => {
        console.log(response);
        this.name = `${response['first_name']} ${response['last_name']}`;
        this.commonService.setUserName(
          response['first_name'] ? response['first_name'] : ''
        );
        localStorage['userName'] = response['first_name']
          ? response['first_name']
          : '';
        if (response['role_id']) {
          localStorage['roleId'] = response['role_id'];
        }
        if (response['user_id']) {
          localStorage['userId'] = response['user_id'];
        }
        localStorage['fullName'] = this.name;
        this.commonService.setFullName(localStorage['fullName']);
        localStorage['havePackage'] =
          !!response['havePackagePurchased'] || false;
        this.havePackage = response['havePackagePurchased'] === true;

        localStorage['haveBatchEnrolled'] =
          response['haveBatchEnrolled'] || false;

        localStorage['haveAcademicCoaching'] =
          response['haveAcademicCoaching'] || false;
        localStorage['haveTestPrep'] = !!response['havePackagePurchased']
          ? false
          : response['haveTestPrep'] || false;

        if (localStorage['roleId'] !== '4')
          this.commonService.setStudentAccess({
            academic: !!response['haveAcademicCoaching'] || false,
            testPrep: response['havePackagePurchased']
              ? false
              : !!response['haveTestPrep'] || false,
            package: !!response['havePackagePurchased'] || false,
          });
        this.getAssignments(localStorage.getItem('userId'));
      },
      (error) => {
        console.log(error);
        // this.notifier.notify('error', 'Unable to fetch data');
      }
    );
    if (localStorage['roleId'] === '4') {
      let selectedChild: childInfo =
        this.parentChildrenServcie.getSelectedChild();
      console.log(selectedChild);
      if (selectedChild?.student_id !== -1) {
        this.children.forEach((child: childInfo, childIndex: number) => {
          if (selectedChild.student_id === child.student_id) {
            this.parentChildrenServcie.setSelectedChildren(
              JSON.stringify(childIndex)
            );
          }
        });
      }
      this.parentChildrenIndexSubscription = this.parentChildrenServcie
        .getSelectedChildren()
        .subscribe((index) => {
          console.log(index);
          this.selectedChild = parseInt(index);
          if (this.children.length > 0) {
            this.studentId = selectedChild.student_id;
            this.hasChartAccess = false;
            this.getAssignments(this.children[this.selectedChild].student_id);
          }
        });
      console.log('this is selected id: ', this.selectedChild);
      this.parentChildrenServcie.setChildrenLoading(true);
      this.httpClient
        .get('/api/get_childrens', {
          headers: {
            Authorization: 'Bearer ' + localStorage['accessToken'],
          },
          responseType: 'json',
        })
        .subscribe(
          (response: any) => {
            console.log(response);
            this.childrenLoading = false;
            this.parentChildrenServcie.setChildrenLoading(false);
            this.parentChildrenServcie.setChildren(response);
            this.parentChildrenArraySubscription =
              this.parentChildrenServcie.children.subscribe((children) => {
                this.children = children;
              });
            // this.children = response;
            // this.parentChildrenServcie.setSelectedChildren('0');
            let selectedChild: childInfo =
              this.parentChildrenServcie.getSelectedChild();
            console.log(selectedChild);
            localStorage.setItem('children', JSON.stringify(response));
            if (selectedChild?.student_id !== -1) {
              this.children.forEach((child: childInfo, childIndex: number) => {
                if (selectedChild.student_id === child.student_id) {
                  this.parentChildrenServcie.setSelectedChildren(
                    JSON.stringify(childIndex)
                  );
                  localStorage.setItem(
                    'selectedChild',
                    JSON.stringify(this.children[childIndex])
                  );
                  this.commonService.setStudentAccess({
                    academic:
                      !!response[childIndex]['haveAcademicCoaching'] || false,
                    testPrep: !!response[childIndex]['haveTestPrep'] || false,
                    package: !!response[childIndex]['havePackage'] || false,
                  });
                  console.log(this.children);
                  if (response.length > 0) {
                    this.getAssignments(response[childIndex].student_id);
                  }
                }
              });
            } else {
              localStorage.setItem(
                'selectedChild',
                JSON.stringify(this.children[0])
              );
              this.commonService.setStudentAccess({
                academic: !!response[0]['haveAcademicCoaching'] || false,
                testPrep: !!response[0]['haveTestPrep'] || false,
                package: !!response[0]['havePackage'] || false,
              });
              console.log(this.children);
              if (response.length > 0) {
                this.getAssignments(response[0].student_id);
              }
            }
          },
          (error) => {
            console.log(error);
            // this.notifier.notify('error', 'Unable to load children');
            this.childrenLoading = false;
            this.parentChildrenServcie.setChildrenLoading(false);
          }
        );
    } else if (localStorage['roleId'] === '3') {
      this.studentId = parseInt(localStorage['userId']) || null;
    }
  }

  getAssignments(studentId: any) {
    // if (!this.assignmentsLoading && !this.eventsLoading) {
    this.assignmentsLoading = true;
    this.eventsLoading = true;
    console.log('events triggered');
    const apiRequests: any = {};
    let studentAccess: StudentAccess | undefined;
    if (localStorage['roleId'] === '3') {
      studentAccess = this.studentAccess;
    } else {
      studentAccess = {
        academic:
          this.children[this.selectedChild]['haveAcademicCoaching'] || false,
        testPrep: this.children[this.selectedChild]['haveTestPrep'] || false,
        package: this.children[this.selectedChild]['havePackage'] || false,
      };
    }
    this.hasChartAccess =
      studentAccess?.testPrep || studentAccess?.package || false;
    this.studentId = studentId;
    console.log(this.studentAccess, studentAccess);
    if (studentAccess?.academic || studentAccess?.testPrep) {
      /* Comment below code to disable api call for student materials  */
      apiRequests.materials = this.globalApiService.getUserFiles(studentId, '');
    }
    // if (studentAccess?.testPrep || studentAccess?.package) {
      /* Comment below code to disable api call for tests  */
      apiRequests.tests = this.practiceTestService.getAllStudentTests(
        studentId,
        localStorage['roleId'] === '4',
        moment().format('MM-DD-YYYY')
      );
    // }
    if (studentAccess?.testPrep) {
      /* Comment below code to disable api call for workshops  */
      apiRequests.workshops = this.workshopService.getWorkshopsByStudentId(
        this.role === '4' ? studentId : localStorage.getItem('userId'),
        moment().format('MM-DD-YYYY')
      );
    }
    if (Object.keys(apiRequests).length === 0) {
      this.assignmentsLoading = false;
      this.assignments = [];
    } else {
      forkJoin(apiRequests).subscribe({
        next: (response: any) => {
          const assigments: any[] = [];
          console.log(response);
          let materials = response['materials']
            ? response['materials'].data || []
            : [];
          let tests = response['tests'] ? response['tests'] : [];
          let workshops: any[] = response['workshops']
            ? response['workshops'].data || []
            : [];
          console.log(workshops);
          const today = moment(new Date());
          today.subtract(1, 'day');
          materials = materials.filter((material: any) => {
            let isSameOrBefore = false;
            console.log(material);
            if (material.due_date) {
              material.dueDate = moment(material.due_date);
              isSameOrBefore = today.isSameOrBefore(material.dueDate);
              if (isSameOrBefore) {
                material.dueByDate = material.dueDate.format('MMM DD');
                material.name = material.file_name;
                material.assignedDate = moment(material.updated_on).format(
                  'DD MMMM'
                );
                material.type = 'assignment';
                material.assignmentType =
                  categories[material.category - 1].name;
              }
            }
            return isSameOrBefore;
          });
          console.log([...tests]);
          tests = tests.filter((test: any) => {
            test.dueDate = moment(test.completeBy);
            test.dueByDate = test.dueDate.format('MMM DD');
            test.name = test.testCode;
            test.type = 'test';
            test.assignmentType = 'test';
            return today.isSameOrBefore(test.dueDate);
          });
          console.log(tests);
          workshops = workshops.filter((workshop) => {
            workshop.dueDate = moment(workshop.dueDate.substring(0, 10));
            console.log(workshop.dueDate);
            workshop.dueByDate = workshop.dueDate.format('MMM DD');
            workshop.name = workshop.workshopName;
            workshop.type = 'workshop';
            workshop.assignmentType = 'workshop';
            workshop.status = workshop.statusCode;
            workshop.testTypeName = workshop.testTypes[0].testTypeName;
            if (workshop.totalQuestions > 0) {
              if (workshop.attemptedQuestions > 0) {
                workshop.status =
                  workshop.attemptedQuestions === workshop.totalQuestions
                    ? 3
                    : 2;
              }
            }
            console.log(
              today,
              workshop.dueDate,
              today.isSameOrBefore(workshop.dueDate)
            );
            return today.isSameOrBefore(workshop.dueDate);
          });
          assigments.push(...materials);
          assigments.push(...tests);
          assigments.push(...workshops);
          assigments.sort((first, next) => {
            return (
              first.dueDate.format('YYYYMMDD') - next.dueDate.format('YYYYMMDD')
            );
          });
          console.log(assigments);
          this.assignments = assigments;
          this.assignmentsLoading = false;
        },
        error: (error: any) => {
          console.log(error);
          this.assignmentsLoading = false;
        },
      });
    }
    // forkJoin(
    //   this.globalApiService.getUserFiles(studentId, ''),
    //   this.practiceTestService.getAllStudentTests(
    //     studentId,
    //     localStorage['roleId']
    //   ),
    //   this.workshopService.getWorkshopsByStudentId(
    //     this.role === '4' ? studentId : localStorage.getItem('userId')
    //   )
    // ).subscribe(
    //   (response: any[]) => {
    //     const assigments: any[] = [];
    //     let materials = response[0].data || [];
    //     let tests = response[1] || [];
    //     let workshops: any[] = response[2].data || [];
    //     console.log(workshops);
    //     const today = moment(new Date());
    //     today.subtract(1, 'day');
    //     materials = materials.filter((material: any) => {
    //       let isSameOrBefore = false;
    //       console.log(material);
    //       if (material.due_date) {
    //         material.dueDate = moment(material.due_date);
    //         isSameOrBefore = today.isSameOrBefore(material.dueDate);
    //         if (isSameOrBefore) {
    //           material.dueByDate = material.dueDate.format('MMM DD');
    //           material.name = material.file_name;
    //           material.assignedDate = moment(material.updated_on).format(
    //             'DD MMMM'
    //           );
    //           material.type = 'assignment';
    //           material.assignmentType = categories[material.category - 1].name;
    //         }
    //       }
    //       return isSameOrBefore;
    //     });
    //     tests = tests.filter((test: any) => {
    //       test.dueDate = moment(test.completeBy);
    //       test.dueByDate = test.dueDate.format('MMM DD');
    //       test.name = test.testCode;
    //       test.type = 'test';
    //       test.assignmentType = 'test';
    //       return today.isSameOrBefore(test.dueDate);
    //     });
    //     workshops = workshops.filter((workshop) => {
    //       workshop.dueDate = moment(workshop.dueDate);
    //       workshop.dueByDate = workshop.dueDate.format('MMM DD');
    //       workshop.name = workshop.workshopName;
    //       workshop.type = 'workshop';
    //       workshop.assignmentType = 'workshop';
    //       workshop.status = workshop.statusCode;
    //       workshop.testTypeName = workshop.testTypes[0].testTypeName;
    //       if (workshop.totalQuestions > 0) {
    //         if (workshop.attemptedQuestions > 0) {
    //           workshop.status =
    //             workshop.attemptedQuestions === workshop.totalQuestions ? 3 : 2;
    //         }
    //       }
    //       console.log(
    //         today,
    //         workshop.dueDate,
    //         today.isSameOrBefore(workshop.dueDate)
    //       );
    //       return today.isSameOrBefore(workshop.dueDate);
    //     });
    //     assigments.push(...materials);
    //     assigments.push(...tests);
    //     assigments.push(...workshops);
    //     assigments.sort((first, next) => {
    //       return (
    //         first.dueDate.format('YYYYMMDD') - next.dueDate.format('YYYYMMDD')
    //       );
    //     });
    //     console.log(assigments);
    //     this.assignments = assigments;
    //     this.assignmentsLoading = false;
    //   },
    //   (error: any) => {
    //     console.log(error);
    //     this.assignmentsLoading = false;
    //   }
    // );
    if (studentAccess?.academic || studentAccess?.testPrep) {
      this.globalApiService.getStudentBatchScheduleEvents(studentId).subscribe(
        (response: BatchScheduleEventsRes) => {
          const now = moment();
          let sone = moment.tz.guess();
          const upcoming: any[] = [];
          (response?.data || [])
            // isDisabled === 1 is the "Active" checkbox on the batch schedule
            .filter((event) => event.isDisabled === 1)
            .forEach((event) => {
              const batchZone = this.timezones[event.timeZone - 1];
              const start = moment
                .tz(
                  `${event.classDate} ${event.startTime}`,
                  'MM-DD-YYYY h:mm A',
                  batchZone
                )
                .tz(sone);
              const end = moment
                .tz(
                  `${event.classDate} ${event.endTime}`,
                  'MM-DD-YYYY h:mm A',
                  batchZone
                )
                .tz(sone);
              if (end.isSameOrBefore(start)) {
                end.add(1, 'day');
              }
              if (end.isBefore(now)) {
                return;
              }
              upcoming.push({
                ...event,
                course: [...new Set(event.courses || [])].join(', '),
                // Same colours as the admin calendar
                colors: classCardColors(event.subject, event.hideDetails),
                startTime: start.format('h:mm A'),
                displayDate: start,
                displayDayString: start.format('ddd, D MMM'),
              });
            });
          upcoming.sort(
            (first, next) => first.displayDate.valueOf() - next.displayDate.valueOf()
          );
          // A week of classes, in the viewer's timezone: from today, or from
          // the next class's day when there are none this week (e.g. a batch
          // whose classes start later)
          const thisWeekEnd = moment().tz(sone).endOf('day').add(7, 'days');
          const first = upcoming[0];
          const startsLater = !!first && first.displayDate.isAfter(thisWeekEnd);
          const windowEnd = startsLater
            ? first.displayDate.clone().endOf('day').add(7, 'days')
            : thisWeekEnd;
          this.events = upcoming.filter(
            (event) => !event.displayDate.isAfter(windowEnd)
          );
          this.eventsFromNote = startsLater
            ? `No classes this week. Showing classes from ${first.displayDate.format('ddd, MMM D')}.`
            : '';
          this.eventsLoading = false;
        },
        (error: any) => {
          console.log(error);
          this.eventsLoading = false;
        }
      );
    } else {
      this.eventsLoading = false;
      console.log('not academic and test prep');
      this.events = [];
      this.eventsFromNote = '';
    }
    // }
  }

  setchildren() {
    alert("I'm triggered");
    console.log(this.selectedChild);
    localStorage.setItem(
      'selectedChild',
      JSON.stringify(this.children[this.selectedChild])
    );
    this.parentChildrenServcie.setSelectedChildren(
      JSON.stringify(this.selectedChild)
    );
    this.commonService.setStudentAccess({
      academic:
        !!this.children[this.selectedChild]['haveAcademicCoaching'] || false,
      testPrep: !!this.children[this.selectedChild]['haveTestPrep'] || false,
      package: !!this.children[this.selectedChild]['havePackage'] || false,
    });
    this.getAssignments(this.children[this.selectedChild].student_id);
  }

  goToTestOrWorkshop(assignment: any) {
    if (assignment.type === 'test') {
      if (assignment.status === 3) {
        this.router.navigateByUrl(`/report/${assignment.studentTestId}`);
      } else {
        const newWindow = window.open(
          `${environment.location}/#/student-test/${assignment.studentTestId}`,
          '_blank',
          `popup,width=${screen.availWidth},height=${screen.availHeight}`
        );
        if (newWindow) {
          let timer = setInterval(() => {
            if (newWindow.closed) {
              this.ngOnInit();
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.router.navigateByUrl(`/online-test/${assignment.studentTestId}`);
        }
      }
    } else {
      this.router.navigateByUrl(`/workshops/view/${assignment.workshopId}`);
    }
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
    if (this.parentChildrenArraySubscription) {
      this.parentChildrenArraySubscription.unsubscribe();
    }
    if (this.parentChildrenIndexSubscription) {
      this.parentChildrenIndexSubscription.unsubscribe();
    }
    this.studentAccessSubscription.unsubscribe();
  }
}
